import { Pipe, PipeTransform } from '@angular/core';
import { TextHelper } from '../helpers/text.helper';

@Pipe({
  name: 'pluralIfCount',
  standalone: false,
})
export class PluralIfCountPipe implements PipeTransform {
  constructor() { }

  private getWithCount(key: string, count: number): string {
    return `${TextHelper.getTextInRightForm(count, key)}`;
  }

  transform(value: string, count: number): string {
    return count <= 1 ? value : this.getWithCount(value, count);
  }
}
